// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var CommonTypes_Shift = require("../../../shared/src/types/CommonTypes_Shift.bs.js");
var CommonTypes_WorkerShift = require("../../../shared/src/types/CommonTypes_WorkerShift.bs.js");

function fromShift(param) {
  return {
          endDatetime: param.endDatetime,
          id: param.id,
          location: param.location,
          shiftType: param.shiftType,
          startDatetime: param.startDatetime,
          timezone: param.timezone
        };
}

function compare(param, param$1) {
  return Curry._2(CommonTypes_Shift.Id.compare, param.id, param$1.id);
}

function eq(param, param$1) {
  return Curry._2(CommonTypes_Shift.Id.eq, param.id, param$1.id);
}

var Ord = {
  compare: compare,
  eq: eq
};

var $$Map = Relude_Map.WithOrd({
      eq: eq,
      compare: compare
    });

var $$Set = Relude_Set.WithOrd({
      eq: eq,
      compare: compare
    });

var Shift = {
  fromShift: fromShift,
  compare: compare,
  eq: eq,
  Ord: Ord,
  $$Map: $$Map,
  $$Set: $$Set
};

function fromWorkerShift(param) {
  return {
          tipAmount: param.tipAmount,
          workerId: param.workerId,
          workerName: param.workerName,
          workerProfilePicture: param.workerProfilePicture,
          workerShiftId: param.id
        };
}

function compare$1(param, param$1) {
  return Curry._2(CommonTypes_WorkerShift.Id.compare, param.workerShiftId, param$1.workerShiftId);
}

function eq$1(param, param$1) {
  return Curry._2(CommonTypes_WorkerShift.Id.eq, param.workerShiftId, param$1.workerShiftId);
}

var Ord$1 = {
  compare: compare$1,
  eq: eq$1
};

var $$Map$1 = Relude_Map.WithOrd({
      eq: eq$1,
      compare: compare$1
    });

var $$Set$1 = Relude_Set.WithOrd({
      eq: eq$1,
      compare: compare$1
    });

var PayTips = {
  fromWorkerShift: fromWorkerShift,
  compare: compare$1,
  eq: eq$1,
  Ord: Ord$1,
  $$Map: $$Map$1,
  $$Set: $$Set$1
};

function getPayTipsToDosFromShift(param) {
  var match = param.tipsPayoutType;
  if (typeof match === "number" && match === 1) {
    return Curry._1(CommonTypes_WorkerShift.Id.$$Map.fromArray, Curry._2(Relude_Array.map, (function (payTips) {
                      return [
                              payTips.workerShiftId,
                              payTips
                            ];
                    }), Curry._2(Relude_Array.map, fromWorkerShift, Relude_Array.keep((function (param) {
                              if (param.clockedOutAt === undefined) {
                                return false;
                              }
                              var match = param.tipAmount;
                              if (typeof match === "number") {
                                return match === 0;
                              } else {
                                return false;
                              }
                            }), param.workerShifts))));
  } else {
    return Curry._1(CommonTypes_WorkerShift.Id.$$Map.make, undefined);
  }
}

function fromShift$1(shift) {
  return {
          shift: fromShift(shift),
          payTipsToDos: getPayTipsToDosFromShift(shift)
        };
}

function compare$2(param, param$1) {
  return compare(param.shift, param$1.shift);
}

function eq$2(param, param$1) {
  return eq(param.shift, param$1.shift);
}

var Ord$2 = {
  compare: compare$2,
  eq: eq$2
};

var $$Set$2 = Relude_Set.WithOrd({
      eq: eq$2,
      compare: compare$2
    });

exports.Shift = Shift;
exports.PayTips = PayTips;
exports.fromShift = fromShift$1;
exports.compare = compare$2;
exports.eq = eq$2;
exports.Ord = Ord$2;
exports.$$Set = $$Set$2;
/* Map Not a pure module */
